import React, { useState } from 'react'
import { Button, Form, Badge } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import * as Constants from '../../../helpers/constants'
import showToastNotification from '../../widgets/toastify'
import { ApiHelper } from '../../../helpers/apihelper'

const initialState = {
  domainsInput: '',
  domains: []
}

const UpdateDisposableDomain = ({ client }) => {
  const [state, setState] = useState(initialState)
  const id = useSelector(state => state.user.id)

  const handleInputChange = (e) => {
    const domainsArray = e.target.value.split(/[,\s\n]+/)
    const filteredDomains = domainsArray.filter(domain => domain.trim() !== '')
    setState({ domainsInput: e.target.value, domains: filteredDomains })
  }

  const handleBlur = () => {
    const domainsArray = state.domainsInput.split(/[,\s\n]+/)
    const filteredDomains = domainsArray.filter(domain => domain.trim() !== '')
    setState(prev => ({ ...prev, domains: filteredDomains }))
  }

  const removeDomain = (index) => {
    const updatedDomains = [...state.domains]
    updatedDomains.splice(index, 1)
    setState({
      domains: updatedDomains,
      domainsInput: updatedDomains.join(', ')
    })
  }

  const handleSaveChanges = () => {
    const requestBody = {
      domains: state.domains,
      user_id: id,
    }

    const body = _.pick(requestBody, ApiHelper(client, 'UPDATE_DISPOSABLE_DOMAINS').API_BODY)

    ApiHelper(client, 'UPDATE_DISPOSABLE_DOMAINS').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: response.data.message,
            isSuccess: false,
          })
        } else if (response.status === Constants.CO_API.SUCCESS) {
          showToastNotification({
            message: response.data.message || 'Updated successfully',
            isSuccess: true,
          })
          setState(initialState)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <div className='mis-wrapper'>
      <h5 className='heading-title'>Update Disposable Domains</h5>
      <p className='heading-subtext'>
        Update Sysprop Disposable domains
      </p>
      <Form className='update-disposable-domains__form'>
        <Form.Group className='mt-4'>
          <Form.Label
            htmlFor='update-disposable-domains__input'
            className='mb-1'
          >
            Enter Domains:
          </Form.Label>
          <Form.Control
            type='text'
            id='update-disposable-domains__input'
            placeholder='Enter comma or space separated domains'
            value={state.domainsInput}
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
        </Form.Group>
        {state.domains.length > 0 && (
          <div className='domain-tags-container'>
            {state.domains.map((domain, index) => (
              <Badge
                key={index}
                className='misc-badges'
              >
                <span>{domain}</span>
                <span onClick={() => removeDomain(index)}>&times;</span>
              </Badge>
            ))}
          </div>
        )}
        <div className='update-disposable-domains__button'>
          <Button
            variant='outline-success'
            onClick={handleSaveChanges}
            disabled={state.domains.length === 0}
          >
            Update
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default UpdateDisposableDomain
